export const INVESTMENT_TYPE = {
  floating: {
    key: 1,
    name: "Investment",
  },

  fixed: {
    key: 2,
    name: "Investment Fixed",
  },
};

export const INVESTMENT_ACTION = {
  cancel: {
    id: 1,
    text: "Cancel",
    key: 'cancel'
  },

  close: {
    id: 3,
    text: "Close",
    key: 'close'
  },
};

export const INVESTMENT_STATUSES = {
  waiting: {
    id: 1,
    text: 'Waiting',
    color: 'warning'
  },

  working: {
    id: 2,
    text: 'Working',
    color: 'success'
  },

  stop: {
    id: 3,
    text: 'Stop',
    color: 'error'
  }
}

export const INVESTMENT_ACTION_STATUSES = {
  cancel: {
    id: 1,
    text: 'Cancel',
  },

  processing: {
    id: 2,
    text: 'Processing',
  },

  close: {
    id: 3,
    text: 'Close',
  },

  finished: {
    id: 4,
    text: 'Finished',
  },
}